import React, {useCallback, useRef} from 'react'
import {useSelector} from 'react-redux'
import {facilityIconsById} from 'components/Accommodation/Facilities/FacilityIcon'
import {getFiltersLabel} from 'components/Filters/utils'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {getFacetFilters} from 'modules/sapiSearch/selectors'
import {getListOfValues} from 'modules/search/selectors'

import {Icon} from '@vio/atlas/Icon'
import {Pill} from '@vio/atlas/Pill'

const filterKeys = ['facilities']
const elementName = 'quickFilterFacilities'

interface Props {
  isActive?: boolean
  facilityId: string
}
export const FacilityQuickFilterPill: React.FC<Props> = ({
  isActive = false,
  facilityId
}) => {
  const listOfValues = useSelector(getListOfValues)
  const buttonRef = useRef<HTMLButtonElement>(null)
  const {facilities} = useSelector(getFacetFilters)

  const {submitFilters, getAppliedFilters} = useFiltersForm(
    filterKeys,
    elementName
  )

  const handlePillClick = useCallback(() => {
    if (isActive) buttonRef.current?.blur()

    const activeFilters = getAppliedFilters()

    const activeFacilities = activeFilters.facilities || []

    const updatedFilters = {
      facilities: isActive
        ? activeFacilities.filter(id => facilityId !== id)
        : [...activeFacilities, facilityId]
    }

    submitFilters(updatedFilters)
  }, [isActive, submitFilters, getAppliedFilters])

  if (isActive || !facilities[facilityId]?.isAvailable) return null

  return (
    <Pill
      dataId={`facilityQuickFilter:${facilityId}`}
      onClick={handlePillClick}
      isSelected={isActive}
      iconStart={<Icon name={facilityIconsById[facilityId]} />}
      iconEnd={isActive && <Icon name={'Close'} />}
    >
      {getFiltersLabel('Facility', facilityId, listOfValues)}
    </Pill>
  )
}
